import React, { useState } from 'react';
import { CheckboxChecked, CheckboxIntermediate, CheckboxUnchecked } from '@fabric-ui/icons';
import { Checkbox, FormControlLabel, SxProps } from '@mui/material';
import { SwitchBaseProps } from '@mui/material/internal/SwitchBase';

export interface AvCheckboxProps {
  label?: React.ReactNode;
  value?: boolean;
  onChange?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
  indeterminate?: boolean;
  disabled?: boolean;
  inputProps?: SwitchBaseProps['inputProps'];
  labelColor?: string;
  size?: 'medium' | 'small';
  sx?: SxProps;
}

const AvCheckbox: React.FC<AvCheckboxProps> = ({
  label,
  value = false,
  onChange = () => {},
  indeterminate,
  disabled,
  inputProps,
  labelColor,
  size = 'medium',
  sx: sxFromProps = {},
}) => {
  const [focused, setFocused] = useState(false);
  const sx = {
    width: 'fit-content',
    gap: '8px',
    margin: 0,
    '.MuiFormControlLabel-label': { color: labelColor, fontSize: size === 'small' ? 12 : undefined },
    ...sxFromProps,
  };
  return (
    <FormControlLabel
      sx={sx}
      control={
        <Checkbox
          checked={value}
          indeterminate={indeterminate}
          icon={<CheckboxUnchecked />}
          checkedIcon={<CheckboxChecked />}
          indeterminateIcon={<CheckboxIntermediate />}
          className={focused ? 'Mui-focused' : ''}
          onChange={event => onChange(event.target.checked, event)}
          inputProps={{ onFocus: () => setFocused(true), onBlur: () => setFocused(false), ...inputProps }}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
};
export { AvCheckbox };
